import { CloseIcon } from "components/atoms/Icon";
import Button from "components/atoms/buttons/Button";
import Modal from "components/atoms/modal";

function getConfirmPublishReleaseText(isWhitelistedRelease: boolean, isPrivateRelease: boolean) {
  if (isWhitelistedRelease && isPrivateRelease) {
    return "This Release is going to be 'Exclusive' as well as 'Private'. This means only the list of users you have provided while making it 'Exclusive' will be able to claim the Magnet. 'Private' implies that the Magnet is claimable only through the private claim page. After publishing the release, you will not be able to edit any details of this release. However, you will be able to end and create a new one. Do you want to publish this release?";
  }
  if (isWhitelistedRelease) {
    return "This Release is going to be 'Exclusive'. This means only the list of users you have provided while making it 'Exclusive' will be able to acquire the Magnet. After publishing the release, you will not be able to edit any details of this release. However, you will be able to end and create a new one. Do you want to publish this release?";
  }
  if (isPrivateRelease) {
    return "This Release is going to be 'Private'. This means users will only be able to claim the Magnet through the private claim page. After publishing the release, you will not be able to edit any details of this release. However, you will be able to end and create a new one. Do you want to publish this release?";
  }
  return "After publishing the release, you will not be able to edit any details of this release. However, you will be able to end and create a new one. Do you want to publish this release?";
}
interface IProps {
  open: boolean;
  onClose: () => void;
  handlePublishRelease: () => void;
  isWhitelistedRelease: boolean;
  isPrivateRelease: boolean;
}
function ConfirmPublishReleaseModal({
  open = false,
  onClose,
  handlePublishRelease,
  isWhitelistedRelease,
  isPrivateRelease,
}: IProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <div className="relative rounded-2xl bg-primary p-8 text-white shadow-modal md:w-[600px]">
        <div className="flex justify-between">
          <div className="w-[95%]">
            <h1 className="font-satoshi text-2xl font-bold leading-tight">Confirm Publish?</h1>
          </div>

          <span role="button" tabIndex={0} onKeyDown={() => {}} onClick={onClose} className="cursor-pointer">
            <CloseIcon className="h-4 w-4 text-white" />
          </span>
        </div>
        <section className="mt-3 w-full font-satoshi text-sm font-450 leading-snug text-white text-opacity-70">
          {getConfirmPublishReleaseText(isWhitelistedRelease, isPrivateRelease)}
        </section>
        <div className="mt-10 flex justify-end gap-3">
          <Button variant="whiteOutline" text="CANCEL" onClick={onClose} additionalClasses="text-xs" />
          <Button
            variant="magnetiqSolid"
            text="PUBLISH RELEASE"
            onClick={handlePublishRelease}
            additionalClasses="text-xs"
          />
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmPublishReleaseModal;
